/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Account')
    .directive('accAccountMenu', [
        'template',
        (template) => {
            const SHOW_QUOTA_LIGHTBOX = 'quota_lightbox';

            return {
                replace: true,
                scope: {
                    showAdministrationLink: '@',
                    showLeaveAdministrationLink: '@'
                },
                templateUrl: template('account/menu'),
                controller: [
                    '$location',
                    '$modal',
                    '$scope',
                    '$translate',
                    'AccountDetailsModal',
                    'CloudPlatformIdentityProvider',
                    'CloudPlatformLoginInfo',
                    'ManageNotificationsModal',
                    'Session',
                    (
                        $location,
                        $modal,
                        $scope,
                        $translate,
                        AccountDetailsModal,
                        CloudPlatformIdentityProvider,
                        CloudPlatformLoginInfo,
                        ManageNotificationsModal,
                        Session
                    ) => {
                        $scope.dropdownOpen = false;
                        $scope.settings = Session.settings;
                        $scope.account = Session.account;
                        $scope.expirationsAvailable = false;
                        $scope.expirations = {};
                        $scope.loading = true;
                        $scope.resetPasswordLink = null;

                        CloudPlatformIdentityProvider.getResetPasswordLink().then((link) => $scope.resetPasswordLink = link);

                        $scope.account.$promise.then(() => $scope.loading = false);

                        $scope.openAccountDetailsDialog = () => AccountDetailsModal();

                        $scope.openManageNotificationsDialog = () => ManageNotificationsModal();

                        $scope.openQuotaDialog = () => _openDialog('Manage Quota', 'account/manage_quota');

                        $scope.openPurgeDialog = () => _openDialog('Purge Now', 'account/purge_content');

                        if ($location.search()[SHOW_QUOTA_LIGHTBOX]) {
                            $scope.openQuotaDialog();
                            $location.search(SHOW_QUOTA_LIGHTBOX, null);
                        }

                        CloudPlatformLoginInfo.getExpirations().then((expirations) => {
                            $scope.expirationsAvailable = true;
                            $scope.expirations = expirations;
                        });

                        function _openDialog(title, template) {
                            $modal.open({
                                domOptions: {
                                    modalAction: 'manageQuota',
                                    modalType: 'notify',
                                    modalBodyTemplate: template,
                                    modalTitle: $translate.instant(title),
                                    modalActionButton: $translate.instant('Close')
                                },
                                controller: 'ManageQuotaModalController',
                                windowClass: 'quota-dialog',
                                backdrop: 'static',
                                keyboard: false
                            });
                        };
                    }
                ]
            };
        }
    ]);
